import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, API } from '../App';
import axios from 'axios';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { updateUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error('Authentication failed');
        navigate('/auth');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for session token
        const response = await axios.get(`${API}/auth/session`, {
          params: { session_id: sessionId },
          
        });

        const { user } = response.data;
        updateUser(user);
        
        toast.success('Welcome to Clierxter Vision Lab!');
        
        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        
        // Check if there was a stored redirect destination (from admin routes etc)
        const storedRedirect = localStorage.getItem('auth_redirect_to');
        if (storedRedirect) {
          localStorage.removeItem('auth_redirect_to');
          navigate(storedRedirect, { state: { user } });
          return;
        }
        
        // Redirect based on onboarding status
        if (!user.onboarding_completed) {
          navigate('/onboarding', { state: { user } });
        } else {
          navigate('/dashboard', { state: { user } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed. Please try again.');
        navigate('/auth');
      }
    };

    processAuth();
  }, [navigate, updateUser]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin w-8 h-8 border-2 border-[#E5C585] border-t-transparent rounded-full mb-4" />
        <p className="text-[#A1A1AA]">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
